export default function TouchdownRushIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" shapeRendering="crispEdges">
      <rect width="64" height="64" rx="12" fill="#3b9735" />
      <rect x="0" y="0" width="64" height="12" fill="#2f4a80" />
      <rect x="10" y="12" width="2" height="52" fill="#f4f6f0" />
      <rect x="31" y="12" width="2" height="52" fill="#f4f6f0" />
      <rect x="52" y="12" width="2" height="52" fill="#f4f6f0" />
      <g transform="rotate(-28 32 38)">
        <ellipse cx="32" cy="38" rx="20" ry="12" fill="#14141c" />
        <ellipse cx="32" cy="38" rx="17.5" ry="9.5" fill="#8b4a1c" />
        <path d="M17 34h4M43 34h4M17 42h4M43 42h4" stroke="#f4f6f0" strokeWidth="2" />
        <rect x="24" y="36" width="16" height="2.4" fill="#f4f6f0" />
        <path d="M26 33v8M29.5 33v8M33 33v8M36.5 33v8" stroke="#f4f6f0" strokeWidth="1.8" />
      </g>
      <path d="M44 6l3 4 5-1-3 4 3 4-5-1-3 4-1-5-5-2 5-2z" fill="#ffd23f" />
    </svg>
  );
}
